// SymbolPicker — input con autocomplete vía datalist HTML nativa.
// Lista de símbolos comunes pero permite escribir cualquier símbolo custom
// (ej: "XAUUSD.fix" si el broker usa sufijos).

import type { ReactElement } from 'react';
import { Input } from '../ui/Input';

const COMMON_SYMBOLS = [
  // Metals
  'XAUUSD',
  'XAGUSD',
  // Forex majors
  'EURUSD',
  'GBPUSD',
  'USDJPY',
  'USDCAD',
  'USDCHF',
  'AUDUSD',
  'NZDUSD',
  // Crosses
  'EURJPY',
  'GBPJPY',
  'EURGBP',
  // Indices
  'US30',
  'US100',
  'NAS100',
  'US500',
  'GER40',
  'UK100',
  // Crypto (suelen variar por broker)
  'BTCUSD',
  'BTCUSDT',
  'ETHUSD',
  'ETHUSDT',
  'SOLUSDT',
  'BNBUSDT',
  // Energy
  'USOIL',
  'UKOIL',
];

interface Props {
  value: string;
  onChange: (v: string) => void;
  label?: string;
}

export function SymbolPicker({ value, onChange, label = 'Símbolo' }: Props): ReactElement {
  return (
    <div>
      <Input
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        placeholder="ej: XAUUSD"
        list="common-symbols"
        className="font-mono"
        autoComplete="off"
      />
      <datalist id="common-symbols">
        {COMMON_SYMBOLS.map((s) => (
          <option key={s} value={s} />
        ))}
      </datalist>
    </div>
  );
}
